<div class="container">
    <div class="row no-gutters">
        <div class="col no-gutters">
            <app-group-classes-search-criteria [form]="form"></app-group-classes-search-criteria>
        </div>
    </div>
    <div class="row no-gutters">
        <div class="col no-gutters">
            <table class="table text-left" *ngIf="model">
                <thead class="list-header">
                    <tr>
                        <th scope="col" class="text-left class-header" translate>GroupClassList.ColumnHeaderClass</th>
                        <th scope="col" class="text-left" translate>GroupClassList.ColumnHeaderDate</th>
                        <th scope="col" class="text-left" translate>GroupClassList.ColumnHeaderLocation</th>
                        <th scope="col" class="text-left" translate>GroupClassList.ColumnHeaderInstructor</th>
                        <th scope="col" translate>GroupClassList.ColumnHeaderStatus</th>
                    </tr>
                </thead>
                <tbody class="bg-white">
                    <tr class="list-row" app-group-classes-list-row
                        *ngFor="let item of model.items; let i = index" [item]="item" (click)="viewDetails(item)"></tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row no-gutters" *ngIf="model && model.items.length == 0">
        <div class="col no-gutters text-center" translate>
            GroupClassList.NoItemsFound
        </div>
    </div>
    <div class="row no-gutters">
        <div class="col no-gutters">
            <button *ngIf="model && model.hasMoreItems" type="button" class="btn btn-primary btn-sm"
                (click)="loadNextPage()" translate>GroupClassList.BtnLoadMore</button>
        </div>
    </div>
</div>
